module.exports = __webpack_public_path__ + "img/google-webdev.d19561a5.svg";